const paramsRequestInterceptors = async function (config) {
   if (!config.request_params) return config;

   var string_request_params = '';
   Object.entries(config.request_params).forEach((request_param, index) => {
      string_request_params += index === 0 ? '?' : '&';
      string_request_params += request_param[0] + '=';
      request_param.forEach((request_param_value, index) => {
         string_request_params += index === 0 ? '' : request_param_value;
      });
   });
   config.url += string_request_params;
   return config;
};

export { paramsRequestInterceptors };
